import { Clapperboard, Sparkles } from 'lucide-react';
import { useState } from 'react';
import { useTeamBrand } from '../branding/TeamBrandContext';

export default function XiaoyingMark({ size = 32, className = '', label = '小影' }) {
  const brand = useTeamBrand();
  const [failedUrl, setFailedUrl] = useState('');
  if (brand.active) return (
    <span className={`xiaoying-mark xiaoying-mark--team ${className}`.trim()} style={{ '--xiaoying-mark-size': `${size}px` }} role="img" aria-label={brand.name}>
      {brand.logoUrl && failedUrl !== brand.logoUrl
        ? <img src={brand.logoUrl} alt="" onError={() => setFailedUrl(brand.logoUrl)} />
        : brand.name.charAt(0)}
    </span>
  );
  return (
    <span
      className={`xiaoying-mark ${className}`.trim()}
      style={{ '--xiaoying-mark-size': `${size}px` }}
      role="img"
      aria-label={label}
    >
      <Clapperboard aria-hidden="true" />
      <Sparkles className="xiaoying-mark__spark" aria-hidden="true" />
    </span>
  );
}
